<template>
  <section class="invest">
      <div class="invest__content container">
        <img class="--mobile" src="../assets/invest/handshake.png">
        <div class="invest__ecommerce">
          <img class="--desktop" src="../assets/invest/handshake.png">
          <div class="invest__ecommerce --text --fade-in-right" data-vertical-ivp-class="--animate">
            <div class="invest__line">
              <h1 class="invest__title">Now is the Time to <span>Invest</span><b>1</b></h1>
            </div>
            <p class="invest__description">
              - The global extended warranty market is growing at a CAGR of 6.7%, expecting to reach $182.3 billion by 2027. <br>
              -  Management recently retired 30,000,000 of their shares, improving the Company's share structure. <br>
              - MHHC's recent inclusion on the OTCQB exchange will increase visibility and transparency. <br><br>
              A Can't Miss Opportunity in Extended Warranties and E-commerce -
              <a href="https://mhhc.app.dealmaker.tech/invitations/c9a88252-39be-4be8-a114-1718712d60b7/view" target="_blank">invest now</a>
            </p>
          </div>
        </div>
        <div class="invest__time">
          <div class="invest__time --text">
            <h1 class="invest__title --fade-in-left" data-vertical-ivp-class="--animate">Our Vision for E-commerce</h1>
            <p class="invest__description --fade-in-left" data-vertical-ivp-class="--animate">
              We believe that an investment in MHHC is an investment in streamlined, efficient online
              shopping, that gives the customers what they are looking based on the most relevant criteria.
              At the same time, the developments made in this area will feed our core business, creating
              new opportunities for us, and new value for shareholders. 
            </p>
          </div>
          <img class="--desktop" src="../assets/invest/invest.png">
        </div>
         <img class="--mobile --last" src="../assets/invest/invest.png">
      </div>
  </section>
</template>

<script>
export default {
  name: 'Invest',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/invest.scss";
</style>
